import { useEffect, useState } from "react";
import { timeAgo } from "@/lib/data";

export function TimeAgo({ iso }: { iso: string }) {
  const [label, setLabel] = useState(() => new Date(iso).toLocaleDateString("az-AZ"));
  useEffect(() => setLabel(timeAgo(iso)), [iso]);
  return <span suppressHydrationWarning>{label}</span>;
}
